var React = require('react');
var createReactClass = require('create-react-class');
var NavListItem = require('./navListItem.jsx');

var QolList = createReactClass({

	getBodyParts: function(bodyParts) {
		return bodyParts.map(function(bodyPart) {
			return bodyPart.friendlyUrl;
		});
	},

	render: function(){
		const { isAdmin } = this.props;
		var list = this.props.qols.map(function (qol, i) {
			if (isAdmin || qol.isActive)
			return (
				<NavListItem
					key={i}
					isActive={qol.isActive}
					type="qol"
					bodyParts={this.getBodyParts(qol.bodyparts).join(' ')}
					cssId={qol.friendlyUrl}
					url={'quality-of-life/' + qol.friendlyUrl}
					title={qol.displayName}
					clickTracking={this.props.clickTracking} />
			);
		}.bind(this));

	    return (
			<li className={'orbit-slide' + (this.props.isActive ? ' is-active' : '')} id={this.props.id}>
				<ul className="special-menu-list" id="qols">
					{list}
					{(isAdmin) &&
						<NavListItem
						key={99}
						isActive={true}
						type="qol"
						url={'quality-of-life/new'}
						title="+ Add new QOL"
						clickTracking={this.props.clickTracking} />
					}
				</ul>
			</li>
	    );
	}
});

module.exports = QolList;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/qolList.jsx